<div
  class="w-full flex flex-col sm:flex-row items-center justify-center select-none z-1 h-[10vh]"
  [ngClass]="
    isLoginMode
      ? 'absolute bottom-0 left-0  gap-4 opacity-70'
      : 'mt-auto gap-2 opacity-40 '
  "
>
  <div class="flex items-center gap-2">
    <span
      *ngIf="!isLoginMode"
      class="text-[10px] font-bold uppercase text-gray-800"
    >
      {{ tenantName$ | async }}
    </span>

    <div *ngIf="!isLoginMode" class="h-3 w-[1px] bg-gray-800"></div>

    <span
      class="text-[10px] uppercase tracking-tighter font-semibold text-gray-800"
    >
      Powered by
    </span>

    <a
      *ngIf="isLoginMode"
      href="https://www.connectsea.com.br"
      target="_blank"
      rel="noopener noreferrer"
      class="cursor-pointer"
    >
      <span class="flex gap-[8px] h-4">
        <img
          src="assets/img/connect-sea/favicon-connectsea-azul.png"
          alt="ConnectSea"
          class="w-auto"
        />
        <img
          src="assets/img/connect-sea/connectsea-logo-text.png"
          alt="ConnectSea"
          class="w-auto"
        />
      </span>
    </a>

    <img
      *ngIf="!isLoginMode"
      src="assets/img/connect-sea/connect-sea-logo-branco.png"
      alt="ConnectSea"
      class="h-4 w-auto brightness-0"
    />
  </div>
</div>
